import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  public opened = !(window.innerWidth <= 700);
  private openedStateChanged$ = new BehaviorSubject<boolean>(this.opened);
  public opened$ = this.openedStateChanged$.asObservable();

  constructor() { }

  public toggle() {
    this.opened = !this.opened;
    this.openedStateChanged$.next(this.opened);
  }
}
